module.exports = __webpack_public_path__ + "static/media/minimize.35dd4a09.svg";